import { PropsWithChildren } from 'react'
import { Link, useMatch } from 'react-router-dom'
import { Text } from '~/components/ui/Text'
import { cn } from '~/utils/common'

interface NavigationItemProps {
  href: string
  className?: string
  isExternal?: boolean
}
export default function NavigationItem({
  children,
  href,
  className,
  isExternal = false,
}: PropsWithChildren<NavigationItemProps>) {
  const isActive = useMatch({ path: href })
  return (
    <Link to={href} target={isExternal ? '_blank' : undefined}>
      <Text
        as='span'
        className={cn(
          'hover:text-white transition-colors text-light-10',
          isActive && 'text-white',
          className,
        )}>
        {children}
      </Text>
    </Link>
  )
}
